import m from "../../geodata/es2015/georgiaSouthOssetiaHigh";
window.am4geodata_georgiaSouthOssetiaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/georgiaSouthOssetiaHigh.js
// module id = null
// module chunks = 